export default "__VITE_ASSET__a9f985db__"